import { BaSeLoading, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useReport } from '../hook/useReport';
import BlockRow from './block-row';
import { Container, ContentBlock } from './dangerous-combinations-style';

function DangerousCombinations() {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [response, setResponse] = React.useState({});
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({ cpf: getRouteParam('cpf'), step: 'COMBINACOES_PERIGOSAS' })
      .then((response) => {
        const left = response.data.slice(0, response.data.length / 2);
        const right = response.data.slice(response.data.length / 2);
        setResponse({ right, left, showStep: response.showStep });
      })
      .catch((error) => {
        setErro(error);
      });
  }, [getRouteParam, getStepData]);

  if (laoding) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }
  if (!response.showStep) {
    return <> </>;
  }
  return (
    <div>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        COMBINAÇÕES PERIGOSAS
      </BaSeParagraph>
      {erro && 'Erro ao carregar dados da sessão COMBINAÇÕES PERIGOSAS!'}
      <Container>
        <ContentBlock>
          {response?.left?.map((item) => (
            <BlockRow
              description={item?.description}
              primary={item?.primary}
              secondary={item?.secondary}
              equalsValues={item?.equalsValues}
            />
          ))}
        </ContentBlock>

        {/* divisao */}
        <ContentBlock>
          {response?.right?.map((item) => (
            <BlockRow
              description={item?.description}
              primary={item?.primary}
              secondary={item?.secondary}
              equalsValues={item?.equalsValues}
            />
          ))}
        </ContentBlock>
      </Container>
    </div>
  );
}

export default DangerousCombinations;

// {
//   "primary": {
//       "title": "Estabelecimento de metas",
//       "max": 25,
//       "value": 10,
//       "greaterValue": true
//   },
//   "secondary": {
//       "title": "Persistência",
//       "max": 25,
//       "value": 5,
//       "greaterValue": false
//   },
//   "description": "Cuidado: Não adianta ter objetivo claro e se no momento de um dificuldade você desiste dele. É provável que esse objetivo não tenha um grande significado para você, ou não traga uma razão para continuar.",
//   "equalsValues": false
// }
